//CSSをバンドル
import 'Src/scss/event.scss'
//共通のJavaScriptを読み込み
import 'Src/js/utils/utils'



/* ここには、表示するリストの数を指定します。 */
var moreNum = 2;

/* 表示するリストの数以降のリストを隠しておきます。 */
$('.EventConts__list:nth-child(n + ' + (moreNum + 1) + ')').addClass('is-hidden');

/* 全てのリストを表示したら「もっとみる」ボタンをフェードアウトします。 */
$('.EventConts__more').on('click', function() {
  $('.EventConts__list.is-hidden').slice(0, moreNum).removeClass('is-hidden');
  if ($('.EventConts__list.is-hidden').length == 0) {
    $('.EventConts__more').fadeOut();
  } 
});

/* リストの数が、表示するリストの数以下だった場合、「もっとみる」ボタンを非表示にします。 */
var list = $(".EventConts__list").length;  
if (list < moreNum) {
  $('.EventConts__more').addClass('is-btn-hidden');
}